'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Image, Flex, Text } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
// import { consoleLog } from '@components/Utility/Shared/SharedService';
import config from '@config';

/* Services */
/* Styles */
import SliderDots from '@app-ila/components/Icons/SliderDots';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Render Slider Image Gallery Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent
 * @returns {ReactElement} Slider Image Gallery Component
 */
const MSRInPersonGallery = ({ sectionContent }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const images = sectionContent?.images?.map(image => image.url);
    let [isEndReached, setIsEndReached] = useState(false);
    let [isEndReachedRight, setIsEndReachedRight] = useState(true);

    useEffect(() => {
        if(currentSlide+1 === 2){
            setIsEndReached(true)
        }
        if(currentSlide === 0){
            setIsEndReached(false)
            setIsEndReachedRight(true)
        }
        if(currentSlide == sectionContent?.images.length -1){
            setIsEndReachedRight(false);
        }
        else
        {
           setIsEndReachedRight(true)
        }

    }, [currentSlide])

    const NextArrow = ({ onClick }) => {
        if (isEndReachedRight) {
            return (
                <Box
                    as="div"
                    pos="absolute"
                    right={{ md: "0px", lg: "-2rem" }}
                    top={{ md: "0px", lg: "10rem" }}
                    // transform="translateY(-50%)"
                    zIndex="10"
                    display={{ base: 'none', md: 'none', lg: 'block' }}
                >
                    <Box
                        cursor="pointer"
                        bgColor="#FFA735"
                        border="0"
                        borderRadius="50%"
                        w={{ base: '32px', sm: '32px', md: '54px', lg: '54px' }}
                        h={{ base: '32px', sm: '32px', md: '56px', lg: '56px' }}
                        bgPos="center"
                        bgRepeat="no-repeat"
                        color="transparent"
                        bgImage={`url(https://www.datocms-assets.com/46272/1692094409-right-arrow.svg)`}
                        bgSize={{ base: '7px', sm: '7px', md: '10px', lg: '10px' }}
                        boxShadow="rgba(0, 0, 0, 0.3) 0 0 15px 0"
                        onClick={onClick}
                    />
                </Box>)
        }
    };

    const PrevArrow = ({ onClick }) => {
        if (isEndReached) {
            return (
                <Box
                    as="div"
                    pos="absolute"
                    left={{ md: "0px", lg: "-2rem" }}
                    top={{ md: "0px", lg: "10rem" }}
                    // transform="translateY(-50%)"
                    zIndex="10"
                    display={{ base: 'none', md: 'none', lg: 'block' }}
                >
                    <Box
                        cursor="pointer"
                        bgColor="#FFA735"
                        border="0"
                        borderRadius="50%"
                        w={{ base: '32px', sm: '32px', md: '54px', lg: '54px' }}
                        h={{ base: '32px', sm: '32px', md: '56px', lg: '56px' }}
                        bgPos="center"
                        bgRepeat="no-repeat"
                        color="transparent"
                        bgImage={`url(https://www.datocms-assets.com/46272/1692094406-left-arrow.svg)`}
                        bgSize={{ base: '7px', sm: '7px', md: '10px', lg: '10px' }}
                        boxShadow="rgba(0, 0, 0, 0.3) 0 0 15px 0"
                        onClick={onClick}
                    />
                </Box>
            );
        }
    };


    const slider_settings = {
        speed: 0,
        dots: false,
        infinite: true,
        centerMode: true,
        autoplay: false,
        lazyLoad: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '0',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (prev, current) => setCurrentSlide(current),
        responsive: [
            {
                breakpoint: 1170,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 834,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
        appendDots: dots => (
            <Flex height="40px" position="relative">
                <Flex
                    marginRight="auto"
                    marginLeft="auto"
                    width="178px"
                    mt="20px"
                    justifyContent="space-between"
                >
                    {dots.map(dot => {
                        const button = dot.props.children;

                        return (
                            <button
                                key={dot.key}
                                style={{
                                    display: 'flex', // Ensure the button content aligns properly
                                    justifyContent: 'center', // Center the content horizontally
                                    alignItems: 'center', // Center the content vertically
                                    width: '16px',
                                    height: '16px',
                                    border: 'none', // Remove default browser border styles
                                    padding: '0', // Ensure no extra padding
                                    margin: '0', // Avoid unwanted margins
                                    borderRadius: '50%',
                                    boxSizing: 'border-box', // Ensure padding and borders are included in dimensions
                                    backgroundColor:
                                        currentSlide.toString() === dot.key ? '#000641' : '#DDDDDD',
                                    cursor: 'pointer',
                                }}
                                onClick={e => {
                                    button.props.onClick(e);
                                    setCurrentSlide(dot.key);
                                }}
                            >
                                <SliderDots
                                    color={currentSlide.toString() === dot.key ? '#000641' : '#DDDDDD'}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
                            </button>
                        );
                    })}
                </Flex>
            </Flex>
        ),
        customPaging: i => (
            <div
                style={{
                    marginTop: '40px',
                    width: '8px',
                    height: '8px',
                    border: 'solid #DDDDDD',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    backgroundColor: '#DDDDDD',
                }}
            ></div>
        ),
    };

    return (
        <>
        <Box mx={{base:'20px', md: '20px', lg: "0px"}} mt={{ base: '0px', md: '0px' }}  overflow={'hidden'}
        height={{base: '164px', md: '164px', lg: '380px'}} position={'relative'}
        >
            <Box p="0px" id="slider-gallery" w="100%" className="image-gallery">
                <Slider {...slider_settings}>
                    {sectionContent?.images?.map((item, index) => {
                        return (
                            <Box key={nanoid()} outline="none" textAlign="center" mx="auto" mt={index / 1 != currentSlide / 1 ? {base: '0rem', md: '0rem', lg:'2.5rem'} : undefined}>
                                <Box
                                    // m={{ base: '5px', md: '0', lg: '0' }}
                                    transform={{ base: 'translateX(0px)', md: 'translateX(-8rem)', xl: 'translateX(-130px)' }}
                                    // height={{base:"270px", md:"365px", xl:"565px"}}
                                    // maxH={'390px'}
                                    overflow="hidden"
                                    // cursor="pointer"
                                    // transition="all 0s linear"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    //   margin={'0 20rem 0 0rem'}
                                    width={{ base: '276px', md: '276px', lg: '500px', }}
                                    height={{ base: '164px', md: '164px', lg: '300px' }}
                                    // bg={'red'}
                                >
                                    <Image
                                        width={{ base: '276px', md: '276px', lg: '500px', }}
                                        height={{ base: '164px', md: '164px', lg: '300px' }}
                                        transition={{base: 'none', md: 'none', lg: "all 0.5s ease"}}
                                        src={item.url}
                                        alt={item.alt}
                                        title={item.title}
                                        objectFit='contain'
                                    />
                                </Box>
                            </Box>
                        )
                    })}
                </Slider>

                <style global jsx>{`
          /* Style for inactive dots */
          #slider-gallery .slick-dots li button {
            border-radius: 50%;
            width: 10px;
            height: 10px;
            transition: all 0.3s ease;
          }
            #slider-gallery .slick-slider {
              width: 1085px;
              margin: 0 auto;
            }

          /* Style for the active dot */
           #slider-gallery .slick-slide.slick-center.slick-current {
            width: 650px !important;
            height: 390px !important;
            }

            #slider-gallery .slick-slide.slick-center.slick-current * {
            width: 650px !important;
            height: 390px !important;
            }

          @media (max-width: 1024px) {
            #slider-gallery .slick-slider {
                width: auto;
            }
            #slider-gallery .slick-slide.slick-center.slick-current  {
              width: 276px !important;
              height: 164px !important;
            }
            #slider-gallery .slick-slide.slick-center.slick-current * {
              width: 276px !important;
              height: 164px !important;
            }
          }
          @media (max-width: 480px) {
            #slider-gallery .slick-slider {
                width: auto;
            }
            #slider-gallery .slick-slide.slick-center.slick-current  {
              width: 276px !important;
              height: 164px !important;
                margin-right: 10px;
            }
            #slider-gallery .slick-slide.slick-center.slick-current * {
              width: 276px !important;
              height: 164px !important;
            }
          }
        `}</style>
            </Box>
        </Box>
        
        <Text 
            textAlign={'center'}
            width={'100%'}
            fontFamily={'FedraSerifAStdBook'}
            fontSize={{base:'16px', md:'22px'}}
            fontWeight={500}
            color={"#fff"}
            pb={{base:'40px', md:'50px', lg:'70px'}}
            pt={{base:'20px', md: '40px', lg:'20px'}}
            >{`${currentSlide+1}/${sectionContent?.images?.length}`}</Text>
        </>
    );
};

export default MSRInPersonGallery;